/* eslint-disable max-len */
import React from 'react';

const CheckIcon = props => (
  <svg width={10} height={8} viewBox="0 0 10 8" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.75 0L3.5 5.25 1.25 3 0 4.25l3.5 3.5 6.5-6.5z"
    />
  </svg>
);

export default CheckIcon;
